import React from 'react';

export const arrayPrinter = (jointer = ', ') => {
  return function ArrayPrinter({ item, itemKey }) {
    const data = Array.isArray(item[itemKey]) ? item[itemKey] : [item[itemKey]];
    return <span>{data.join(jointer)}</span>;
  };
};
